<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="orderNo" placeholder="订单号"></el-input>
                        <el-select v-model="invoiceType" placeholder="发票类型">
                            <el-option label="普通发票" value="NORMAL"> </el-option>
                            <el-option label="专用发票" value="SPECIAL"> </el-option>
                        </el-select>
                        <el-select v-model="billType" placeholder="开票类型">
                            <el-option label="企业" value="ENTERPRISE"> </el-option>
                            <el-option label="个人" value="PERSONAL"> </el-option>
                        </el-select>
                        <el-select v-model="receipt" placeholder="是否开票">
                            <el-option label="已开票" value="YES"> </el-option>
                            <el-option label="未开票" value="NO"> </el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="orderNo"
                                label="订单号"
                                header-align="center"
                                show-overflow-tooltip
                                width="240px"
                                align="center">
                            </el-table-column>

                            <el-table-column
                                prop="invoiceTypeCn"
                                label="发票类型"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="billTypeCn"
                                align="center"
                                header-align="center"
                                label="开票类型" >
                            </el-table-column>

                            <el-table-column
                                prop="receipt"
                                align="center"
                                header-align="center"
                                label="是否开票">
                                <template slot-scope="scope">
                                    {{ scope.row.receipt==='YES'?'已开票':'未开票' }}
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="createTime"
                                align="center"
                                header-align="center"
                                label="创建时间">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="getDetail(scope.row.uuid)">查看</el-button>
                                    <el-button type="text" size="small" v-show="scope.row.receipt == 'NO'" @click="openInvoice(scope.row.uuid)">开票</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="开票信息"
            :visible.sync="detailDialog"
            width="1000px" :close-on-click-modal="false">
            <div class="examine">
                <div class="examineList examineListTwo">
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">订单编号:</p>
                        <p>{{ invoiceInfo.orderNo }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">发票类型:</p>
                        <p>{{ invoiceInfo.invoiceTypeCn }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">开票类型:</p>
                        <p>{{ invoiceInfo.billTypeCn }}</p>
                    </div>
                </div>
                <div class="examineList examineListTwo" v-if="invoiceInfo.addressInfo !=null">
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">收件人:</p>
                        <p>{{ invoiceInfo.addressInfo.receiverName }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">手机号:</p>
                        <p>{{ invoiceInfo.addressInfo.mobile }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">收件地址:</p>
                        <p>{{invoiceInfo.addressInfo.province}}{{invoiceInfo.addressInfo.city}}{{invoiceInfo.addressInfo.district}}{{invoiceInfo.addressInfo.areaInfo}}</p>
                    </div>
                </div>
                <div class="examineList examineListTwo" v-if="invoiceInfo.invoiceTitle !=null">
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">抬头:</p>
                        <p>{{ invoiceInfo.invoiceTitle.title }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">税号:</p>
                        <p>{{ invoiceInfo.invoiceTitle.code }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">地址:</p>
                        <p>{{ invoiceInfo.invoiceTitle.address }}</p>
                    </div>
                </div>
                <div class="examineList examineListTwo">
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">物流单号:</p>
                        <p>{{ invoiceInfo.expressCode }}</p>
                    </div>
                    <div class="examineListTwo_box">
                        <p style="white-space:nowrap">物流公司:</p>
                        <p>{{ invoiceInfo.expressCompany }}</p>
                    </div>
                </div>
                <div class="tableBox">
                    <el-table :data="invoiceInfo.invoiceFileList" border>
                        <el-table-column prop="modelName" label="文件名称" align="center">
                            <template slot-scope="scope">
                                <div class="designerImg">
                                    <p>{{ scope.row.fileName }}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <div class="">
                                    <div>
                                        <el-button type="text" size="small" @click="downloadFile(scope.row.fileUrl)">下载</el-button>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="examine_btn">
                <el-button @click="detailDialog = false" type="primary">关闭</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="开票信息"
            :visible.sync="invoiceDialog"
            width="900px">
            <div class="dialogContent" v-loading="loading">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="物流单号" prop="expressCode" >
                        <el-input v-model="form.expressCode" style="width: 220px;" placeholder="请输入物流单号"></el-input>
                    </el-form-item>
                    <el-form-item label="物流公司" prop="expressName" >
                        <el-select v-model="form.expressName" placeholder="请选择物流公司">
                            <el-option
                                v-for="item in expressNameList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发票凭证" prop="invoiceFileList">
                        <div style="display: flex;flex-wrap: wrap;">
                            <div class="imgListClass"
                                 v-for="(item,index) in form.invoiceFileList" v-if="item">
                                <el-image
                                    :src="item.fileUrl" :preview-src-list="previewList">
                                </el-image>
                                <div class="img-cover-wrap">
                                    <i @click.stop="del(index)" class="el-icon-error"></i>
                                </div>
                            </div>
                        </div>
                        <el-upload
                            action="/service-center/upload/file/single"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload" class="thumbnailClass">
                            <div class="avatar">
                                <el-button>点击上传</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {appletInvoiceQuerySx, appletInvoiceInfoSx, voucherSx, getDictionaryItem} from '../../utils/interface';

    export default {
        components: {
        },
        data() {
            return {
                orderNo:'',
                invoiceType: '',
                billType:'',
                receipt:'',
                tableData: [],
                current: 1,
                pageSize: 10,
                total: 0,
                uuid:"",
                detailDialog:false,
                invoiceDialog: false,
                invoiceInfo:{
                    addressInfo:{
                        receiverName:'',
                        mobile:'',
                        province:'',
                        city:'',
                        district:'',
                        areaInfo:''},
                    invoiceTitle:{title:'',
                        title:'',
                        code:'',
                        address:'',}},
                form: {
                    expressCode: '',
                    invoiceFileList: [],
                    expressName: ''
                },
                rules: {
                    expressCode: [
                        {required: true, message: '请输入物流单号', trigger: 'blur'}
                    ],
                    invoiceFileList: [
                        {required: true, message: '请上传图片'}
                    ],
                    expressName: [
                        {required: true, message: '请选择物流公司',trigger: 'change'}
                    ],
                },
                headers: {
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem("api_access_token")
                },
                previewList: [],
                loading: false,
                expressNameList:[],
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.getList();
            this.getDictionaryItem();
        },
        methods: {
            getList(){
                let params = {
                    orderNo:this.orderNo,
                    invoiceType:this.invoiceType,
                    billType:this.billType,
                    receipt:this.receipt,
                    current:this.current,
                    pageSize:this.pageSize,
                }
                appletInvoiceQuerySx(params).then((res)=>{
                    this.tableData = res.data;
                    this.total = res.total;
                });
            },
            resetData(){
                this.orderNo = '';
                this.invoiceType = '';
                this.billType = '';
                this.receipt = '';
                this.current = 1;
                this.getList();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
                this.current = 1;
                this.getList();
            },

            init(){
                this.orderNo = '';
                this.invoiceType = '';
                this.billType = '';
                this.receipt = '';
                this.current = 1;
                this.getList()
            },
            getDetail(uuid){
                this.expressNameList = [];
                this.invoiceInfo={};
                this.detailDialog = true;
                this.uuid = uuid;
                appletInvoiceInfoSx(uuid).then((res)=>{
                    this.invoiceInfo = res.data;
                })
            },
            openInvoice(uuid){
                this.uuid = uuid;
                this.invoiceDialog = true;
            },
            downloadFile(fileUrl){
                let a = document.createElement('a');
                a.href = fileUrl;
                a.click();
            },
            // 效果图上传
            handleAvatarSuccess(res, file) {
                this.form.invoiceFileList.push({
                    fileName: res.name,
                    fileUrl: res.url
                })
                this.previewList.push(res.url)
                this.$refs.ruleForm.validateField('invoiceFileList')
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.warning('上传图片只能是图片格式!');
                }
                if (!isLt2M) {
                    this.$message.warning('上传图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            // 图片删除
            del(index){
                this.form.invoiceFileList.splice(index,1)
                this.previewList.splice(index,1)
                this.$refs.ruleForm.validateField('invoiceFileList')
            },
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        voucherSx(this.uuid,this.form).then((res)=>{
                            this.$message.success('保存成功！')
                            this.loading = false
                            this.invoiceDialog = false
                            this.getList();
                        })
                    } else {
                        return false;
                    }
                });
            },
            getDictionaryItem() {
                getDictionaryItem({groupCode: "delivery_type"}).then((res) => {
                    res.forEach((item, index) => {
                        this.expressNameList.push({name: item.name, id: item.code});
                    });
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 220px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                }

                .tableContent {
                    min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
    .examine {
        h2 {
            font-weight: 700;
            font-size: 16px;
            color: #000;
            margin-top: 26px;
            letter-spacing: 1px;
        }
        .examineList {
            display: flex;
            // align-items: center;
            img {
                width: 300px;
                height: 150px;
            }
            p:nth-of-type(1){
                margin-right: 16px;
                width: 65px;
                flex-shrink: 0;
            }
            .examine_html {
                width: 90%;
                /deep/pre {
                    white-space: pre-line !important;
                }
                /deep/img {
                    max-width: 100%;
                }
            }
        }
        .examineListTwo {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #efefef;
            .examineListTwo_box {
                display: flex;
                align-items: center;
                width: 33%;
            }
        }

    }
    .examine_btn {
        margin-top: 16px;
        width: 100%;
        text-align: right;
    }
    .imgListClass{
        width: 275px;
        height: 150px;
        border: solid 1px #ececec;
        background-color: #f9f9f9;
        margin-right: 13px;
        margin-bottom: 13px;
        position: relative;
        &:hover{
            .img-cover-wrap{
                display: block;
            }
        }
        /deep/.el-image__preview{
            width: 275px;
            height: 150px;
        }
        // 删除
        .img-cover-wrap {
            right: 5px;
            top: 5px;
            position: absolute;
            line-height: initial;
            display: none;
            i {
                font-size: 22px;
                color: #000;
                display: inline;
                cursor: pointer;
            }
        }
    }
    .tableBox {
        margin-top:24px;
        p {
            margin: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/appletSx/appletInvoiceList.vue